// extracted by mini-css-extract-plugin
module.exports = {"flightInfoSquare":"FlightInfoSquare_flightInfoSquare__2zDvx","firstLine":"FlightInfoSquare_firstLine__2Eu9g"};